import { MutateFn } from '@diritto/common/base/mutateFunction';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { activityPointQueryKey } from 'queries/activityPoint/queryKey';
import { AttendanceCheckApi } from 'api/ApiHelper';

export const useDeleteAttendanceCheckNotiMutation = (callback: MutateFn) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: activityPointQueryKey.attendanceCheckNoti(),
    mutationFn: () => AttendanceCheckApi.deleteNoti(),
    onMutate: callback.onMutate,
    onSuccess: (data, variables) => {
      callback.onSuccess?.(data, variables);
      queryClient.invalidateQueries({ queryKey: activityPointQueryKey.attendanceCheckNoti() });
    },
    onError: callback.onError,
  });
};
